import axios, { AxiosError, AxiosInstance } from "axios";
import { ApiRequestConfig, ApiResponse, IApiClient, createApiResponseFromCaughtError } from 'api/api';
import { createApiResponseFromAxiosError, createApiResponseFromAxiosResponse } from 'api/axiosApi';
import { handleApiErrorDefault } from 'api/handleApiError';

export default class ApiClient implements IApiClient {
  protected client: AxiosInstance;

  protected createAxiosClient(baseUrl: string): AxiosInstance {
    const axiosClient = axios.create({
      baseURL: baseUrl,
      //timeout: 10 * 1000,
    });
    return axiosClient;
  }

  constructor(baseUrl: string) {
    this.client = this.createAxiosClient(baseUrl);
  }

  async get<TResponse = any>(
    path: string,
    config?: ApiRequestConfig
  ): Promise<ApiResponse<TResponse>> {
    try {
      const response = await this.client.get<TResponse>(path, config);
      return createApiResponseFromAxiosResponse(response);
    } catch (error) {
      return this.handleError(error);
    }
  }

  async post<TRequest = any, TResponse = any>(
    path: string,
    payload: TRequest,
    config?: ApiRequestConfig
  ): Promise<ApiResponse<TResponse>> {
    try {
      var response = await this.client.post<TResponse>(path, payload, config);
      return createApiResponseFromAxiosResponse(response);
    } catch (error) {
      return this.handleError(error);
    }
  }

  async put<TRequest = any, TResponse = any>(
    path: string,
    payload: TRequest,
    config?: ApiRequestConfig
  ): Promise<ApiResponse<TResponse>> {
    try {
      const response = await this.client.put<TResponse>(path, payload, config);
      return createApiResponseFromAxiosResponse(response);
    } catch (error) {
      return this.handleError(error);
    }
  }

  async delete<TResponse = any>(
    path: string,
    config?: ApiRequestConfig
  ): Promise<ApiResponse<TResponse>> {
    try {
      const response = await this.client.delete<TResponse>(path, config);
      return createApiResponseFromAxiosResponse(response);
    } catch (error) {
      return this.handleError(error);
    }
  }

  private handleError<TResponse>(error: unknown) {
    handleApiErrorDefault(error);
    var axiosError = error as AxiosError<TResponse>;
    if (axiosError) {
      return createApiResponseFromAxiosError(axiosError);
    }
    return createApiResponseFromCaughtError(error);
  }
}